import React from 'react'
import { ICellRendererParams } from 'ag-grid-enterprise'
import { Button } from 'antd'
import { Sigma } from 'lucide-react'
import { EnhancedStatementRow } from '../../../../utils/dataEnhancement'
import { DualValueCell } from '../DualValueCell'
import { shouldUseDualValueDisplay } from '../../../../utils/columnUtils'
import { FlexCellContent, TruncatableText, NoShrinkContainer } from '../CellComponents'
import { BudgetMethodButton } from './BudgetMethodButton'

export const AccountNameCellRenderer: React.FC<ICellRendererParams<EnhancedStatementRow>> = params => {
  const { data, context } = params
  const code = data?._sourceAccountCode
  const name = data?.name
  const fullDisplayName = `${code} - ${name}`

  // Show budget button if edit mode is active (from grid context)
  const showBudgetButton = context?.isEditMode

  // Use dual value display only when in edit mode for directly editable rows (excludes driver-based)
  if (shouldUseDualValueDisplay(params) && context?.isEditMode) {
    return (
      <FlexCellContent>
        <TruncatableText>{fullDisplayName}</TruncatableText>
        <NoShrinkContainer>
          <DualValueCell
            calculatedContent={
              <Button icon={<Sigma style={{ width: 16, height: 16 }} />} type="text" size="small" disabled />
            }
            inputContent={<BudgetMethodButton data={data} style={{ height: '20px', marginLeft: '0px' }} />}
            style={{ justifyContent: 'space-between' }}
          />
        </NoShrinkContainer>
      </FlexCellContent>
    )
  }

  return (
    <FlexCellContent>
      <TruncatableText>{fullDisplayName}</TruncatableText>
      {showBudgetButton && (
        <NoShrinkContainer>
          <BudgetMethodButton data={data} style={{ height: '20px', marginLeft: '4px' }} />
        </NoShrinkContainer>
      )}
    </FlexCellContent>
  )
}
